import { useEffect, useState } from "react";
import { Button, message, Row, Col, Form, Input, Switch, Select } from "antd";
import { postData, getData } from "../../../../apiServices/common";
import { CREATE_BUYER_ENDPOINT, GET_USERS_ENDPOINT } from "../../../../apiServices/API_ENDPOINTS";
import { isArrayAndHasValue } from "../../../../utils/functions";
import CreateMerchandiserForm from "../../../Buyer/CreateMerchandiserForm";

const { Option } = Select;

const BuyerForm = (props) => {
  const { onCloseModal, refetch, onBuyerCreated } = props;

  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [createdUserList, setCreatedUserList] = useState([]);

  const [modalForm] = Form.useForm();

  useEffect(() => {
    getUserList();
  }, []);

  const getUserList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 100,
      ...(filterValues?.name && { name: filterValues.name }),
    };
    const response = await getData(GET_USERS_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setUserList(response?.data?.data?.data || []);
    }
  };

  const createNewEntry = async (formValues) => {
    setLoading(true);

    const bodyData = {
      name: formValues?.name,
      short_name: formValues?.short_name,
      address: formValues?.address,
      merchandiser_for_procurement: formValues?.merchandiser_for_procurement,
      status: formValues?.status ? "1" : "0",
      use_both_style_po: formValues?.use_both_style_po ? "1" : "0",
      buyer_unique_id: "1",
      mmd_users: isArrayAndHasValue(createdUserList)
        ? createdUserList.map((item) => ({
            id: 0,
            user_id: item?.mmd_user_id,
            is_delete: 0,
            buying_office_id: item?.buying_office_id,
            status: item?.status || "Merchandiser",
          }))
        : [],
    };

    const response = await postData(CREATE_BUYER_ENDPOINT, bodyData);

    if (response && response?.code === 200) {
      setLoading(false);
      message.success("Entry Created Successfully");
      const newBuyer = response?.data;
      if (onBuyerCreated && newBuyer) {
        onBuyerCreated(newBuyer);
      } else {
        refetch?.();
      }
      modalForm.resetFields();
      setCreatedUserList([]);
      onCloseModal();
    } else {
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const handleDiscard = () => {
    modalForm.resetFields();
    setCreatedUserList([]);
    onCloseModal();
  };

  return (
    <>
      <Form
        form={modalForm}
        layout="vertical"
        onFinish={createNewEntry}
        initialValues={{
          status: true,
          use_both_style_po: false,
        }}
      >
        <Row gutter={6}>
          <Col span={12}>
            <Form.Item
              label="Buyer Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please input Buyer name!",
                },
              ]}
            >
              <Input placeholder="Ex: Buyer Name" size="small" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Buyer Short Name"
              name="short_name"
              rules={[
                {
                  required: true,
                  message: "Please input buyer short name!",
                },
              ]}
            >
              <Input placeholder="Ex: Buyer Short Name" size="small" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Address"
              name="address"
              rules={[
                {
                  required: true,
                  message: "This field is required!",
                },
              ]}
            >
              <Input placeholder="Please input address" size="small" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Merchandiser for Procurement"
              name="merchandiser_for_procurement"
              rules={[
                {
                  required: true,
                  message: "Please select a Merchandiser!",
                },
              ]}
            >
              <Select
                placeholder="Select a Merchandiser"
                size="small"
                showSearch
                onSearch={(value) => getUserList({ name: value })}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {isArrayAndHasValue(userList) &&
                  userList.map((user) => (
                    <Option key={user.id} value={user.id}>
                      {user.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="status"
              label="Active Status"
              className="collection-create-form_last-form-item"
              valuePropName="checked"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" size="small" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="use_both_style_po"
              label="Use both style & PO"
              className="collection-create-form_last-form-item"
              valuePropName="checked"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" size="small" />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <CreateMerchandiserForm
        createdUserList={createdUserList}
        setCreatedUserList={setCreatedUserList}
        isEdit={false}
      />

      <Row gutter={6}>
        <Col span={12}>
          <Button
            type="danger"
            style={{ width: "100%" }}
            onClick={handleDiscard}
            size="small"
          >
            Discard
          </Button>
        </Col>
        <Col span={12}>
          <Button
            type="primary"
            style={{ width: "100%" }}
            loading={loading}
            size="small"
            onClick={() => modalForm.submit()}
          >
            Save
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default BuyerForm;
